export default __webpack_public_path__ + "static/banner5-50740808b9940def7d87b3a167dbf352.png";